const PATH_PREFIX = '/product/:companyID';

export default [
  {
    name: 'product.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'product.categories',
    path: `${PATH_PREFIX}/categories`,
  },
  {
    name: 'product.category',
    path: `${PATH_PREFIX}/categories/:docID`,
  },
  {
    name: 'product.list',
    path: `${PATH_PREFIX}/products`,
  },
  {
    name: 'product.import',
    path: `${PATH_PREFIX}/import/product`,
  },
  {
    name: 'product.import.image',
    path: `${PATH_PREFIX}/import/image`,
  },
  {
    name: 'product.information',
    path: `${PATH_PREFIX}/products/:docID/information`,
  },
  {
    name: 'product.variation',
    path: `${PATH_PREFIX}/products/:docID/variation`,
  },
  {
    name: 'product.description',
    path: `${PATH_PREFIX}/products/:docID/detail`,
  },
  {
    name: 'product.ecommerce',
    path: `${PATH_PREFIX}/products/:docID/ecommerce`,
  },
  {
    name: 'product.packaging',
    path: `${PATH_PREFIX}/products/:docID/packaging`,
  },
  {
    name: 'product.inventory',
    path: `${PATH_PREFIX}/products/:docID/inventory`,
  },
  {
    name: 'product.shipment',
    path: `${PATH_PREFIX}/products/:docID/shipment`,
  },
  {
    name: 'product.media',
    path: `${PATH_PREFIX}/products/:docID/media`,
  },
  {
    name: 'product.developer.overwrite',
    path: `${PATH_PREFIX}/products/:docID/developer/overwrite`,
  },
  {
    name: 'product.developer.schemaMarkup',
    path: `${PATH_PREFIX}/products/:docID/developer/schemaMarkup`,
  },
  {
    name: 'product.dropshipping.list',
    path: `${PATH_PREFIX}/dropshipping`,
  },
  {
    name: 'product.dropshipping.price',
    path: `${PATH_PREFIX}/dropshipping/price/management`,
  },
  {
    name: 'product.dropshipping.inventory',
    path: `${PATH_PREFIX}/dropshipping/inventory/management`,
  },
  {
    name: 'product.dropshipping.dropshipper',
    path: `${PATH_PREFIX}/dropshipping/dropshipper`,
  },
  {
    name: 'product.dropshipping.dropshipper.approved',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/approved`,
  },
  {
    name: 'product.dropshipping.dropshipper.approved.detail',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/approved/:docID`,
  },
  {
    name: 'product.dropshipping.dropshipper.disapproved',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/disapproved`,
  },
  {
    name: 'product.dropshipping.dropshipper.pending',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/pending`,
  },
  {
    name: 'product.dropshipping.dropshipper.pending.detail',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/pending/:docID`,
  },
  {
    name: 'product.dropshipped.list',
    path: `${PATH_PREFIX}/dropshipped`,
  },
  {
    name: 'product.dropshipped.vendor',
    path: `${PATH_PREFIX}/dropshipped/vendors`,
  },
  {
    name: 'product.dropshipped.vendor.detail',
    path: `${PATH_PREFIX}/dropshipped/vendors/:toCompanyID`,
  },
  {
    name: 'product.dropshipped.category',
    path: `${PATH_PREFIX}/dropshipped/category`,
  },
  {
    name: 'product.dropshipped.price',
    path: `${PATH_PREFIX}/dropshipped/price/management`,
  },
  {
    name: 'product.dropshipped.request',
    path: `${PATH_PREFIX}/dropshipped/request`,
  },
  {
    name: 'product.dropshipped.request.detail',
    path: `${PATH_PREFIX}/dropshipped/request/:toCompanyID`,
  },
];
